var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/ic_delete.5af63014.png","uri@2x": __webpack_public_path__ + "static/media/ic_delete.7d63e54a.png","uri@3x": __webpack_public_path__ + "static/media/ic_delete.67c3d37e.png",
    width: 14,
    height: 18
});